module.exports = __webpack_public_path__ + "img/Thumbs up Icon - white.dddc1369.svg";